import { AppBrands } from '../constants'

const appBrand = process.env.VUE_APP_AppBrand

export default class Environment {
  static isCCFBrandEnv () {
    return appBrand === AppBrands.c1l || appBrand === AppBrands.ccc || appBrand === AppBrands.ccf || appBrand === AppBrands.chs || appBrand === AppBrands.cic || appBrand === AppBrands.esm || appBrand === AppBrands.rpc || appBrand === AppBrands.spc
  }

  static isTMXBrandEnv () {
    return appBrand === AppBrands.inl || appBrand === AppBrands.tbs || appBrand === AppBrands.tmx
  }

  static environment = (process.env.VUE_APP_EnvironmentClass || process.env.NODE_ENV).toLowerCase()

  static isLowerEnv () {
    return Environment.environment === 'development' || Environment.environment === 'dev' || Environment.environment === 'qa' || Environment.environment === 'test' || Environment.environment === 'stage'
  }

  static isProdEnv () {
    return Environment.environment === 'production' || Environment.environment === 'prod' || Environment.environment === 'beta'
  }
}
